"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeDropdown = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var sdk_model_1 = require("@gooddata/sdk-model");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var AttributeDropdownBody_1 = require("./AttributeDropdownBody");
var react_intl_1 = require("react-intl");
var getItemTitle = function (selectedItem, intl) {
    return selectedItem ? selectedItem.title : intl.formatMessage({ id: "rankingFilter.allRecords" });
};
var getItemIcon = function (selectedItem) {
    if (selectedItem) {
        return selectedItem.type === "DATE" ? "gd-icon-date" : "gd-icon-attribute";
    }
    else {
        return null;
    }
};
var AttributeDropdownComponent = function (_a) {
    var items = _a.items, selectedItemRef = _a.selectedItemRef, onSelect = _a.onSelect, onDropDownItemMouseOver = _a.onDropDownItemMouseOver, onDropDownItemMouseOut = _a.onDropDownItemMouseOut, customGranularitySelection = _a.customGranularitySelection, intl = _a.intl;
    var _b = react_1.useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var isDisabled = items.length === 1;
    var onButtonClick = function () {
        setIsOpen(!isOpen);
    };
    var onItemSelect = function (ref) {
        onSelect(ref);
        setIsOpen(false);
        onDropDownItemMouseOut && onDropDownItemMouseOut();
    };
    var buttonClassNames = classnames_1.default("gd-button-secondary", "gd-button-small", "button-dropdown", "gd-icon-right", {
        "gd-icon-navigateup": isOpen,
        "gd-icon-navigatedown": !isOpen,
    }, "gd-rf-attribute-dropdown-button", "s-rf-attribute-dropdown-button");
    var selectedAttributeItem = items.find(function (item) { return sdk_model_1.areObjRefsEqual(item.ref, selectedItemRef); });
    var itemTitle = getItemTitle(selectedAttributeItem, intl);
    return isDisabled ? (react_1.default.createElement(sdk_ui_kit_1.BubbleHoverTrigger, { showDelay: 0, hideDelay: 0 },
        react_1.default.createElement(sdk_ui_kit_1.Button, { className: buttonClassNames, value: itemTitle, disabled: true }),
        react_1.default.createElement(sdk_ui_kit_1.Bubble, { className: "bubble-primary gd-rf-tooltip-bubble s-rf-attribute-no-options-bubble", alignPoints: [{ align: "cr cl" }, { align: "cl cr" }] },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "rankingFilter.attributeDropdown.oneAttributeTooltip" })))) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(sdk_ui_kit_1.Button, { className: buttonClassNames, value: itemTitle, onClick: onButtonClick, iconLeft: getItemIcon(selectedAttributeItem) }),
        isOpen && (react_1.default.createElement(AttributeDropdownBody_1.AttributeDropdownBody, { items: items, selectedItemRef: selectedItemRef, onSelect: onItemSelect, onClose: function () { return setIsOpen(false); }, onDropDownItemMouseOver: onDropDownItemMouseOver, onDropDownItemMouseOut: onDropDownItemMouseOut, customGranularitySelection: customGranularitySelection }))));
};
exports.AttributeDropdown = react_intl_1.injectIntl(AttributeDropdownComponent);
//# sourceMappingURL=AttributeDropdown.js.map